import {TheaterSize} from "../state/theaterStore";
import CsInstance from "../state/CsInstance";

const KnownSidebarMethods = [
	"documentation",
	"toggleTheater",
	"imageAssets",
	"getReadMe",
	"settings",
] as const;

export type SidebarMethods = {
	[K in (typeof KnownSidebarMethods)[number]]: {
		title: string;
		onClick: (props: SidebarMethodsProps) => void;
	};
};

type SidebarMethodsProps = {
	csInstance: CsInstance;
};

/**
 * Returns an object that contains data for a consumer to implement CS's sidebar
 * buttons as they please.
 *
 * A sidebarMethod may have the following properties:
 *   - title: A string to be displayed as a tooltip when hovering over the button.
 *   - onClick: A function that will be called when the button is clicked.
 */
function createSidebarMethods(): SidebarMethods {
	const sidebarMethods = {
		toggleTheater: {
			title: "Side Panel",
			onClick: ({csInstance}) => {
				if (csInstance.theaterStore.theaterSize === TheaterSize.None) {
					csInstance.theaterStore.theaterSize = TheaterSize.Medium;
				} else {
					csInstance.theaterStore.theaterSize = TheaterSize.None;
				}
			},
		},
		documentation: {
			title: "Documentation",
			onClick: () => {
				window.open(
					"https://cs-curriculum-assets.artofproblemsolving.com/docs/AopsTheater/package-summary.html",
					"_blank"
				);
			},
		},
		imageAssets: {
			title: "Image Assets",
			onClick: () => {
				window.open(
					"https://cs-curriculum-assets.artofproblemsolving.com/view/index.html",
					"_blank"
				);
			},
		},
		getReadMe: {
			title: "README",
			onClick: () => {},
		},
		settings: {
			title: "Settings",
			onClick: () => {},
		},
	} satisfies SidebarMethods;

	return sidebarMethods;
}

export default createSidebarMethods;
